export interface CustomerVoice {
  id: string;
  role: string;
  team: string;
  theme: string;
  quote: string;
  accent: 'blue' | 'orange' | 'navy';
}

export const voices: CustomerVoice[] = [
  {
    id: 'architect',
    role: '架构师',
    team: '团队约 20 人',
    theme: '全链路自动化与环境复用',
    quote:
      '这次培训是把 AI Coding 从"碎片"变成了"工具"，让大家看到了从需求到代码提交可以自动化跑通的可能性。CLAUDE.md、Skills、Rules 这套环境配置是一次性的，配好后可以复用到各个项目，不需要每次都重新调教 AI，确实做到了一劳永逸。',
    accent: 'blue',
  },
  {
    id: 'dev-director',
    role: '研发总监',
    team: '团队约 50 人',
    theme: '组织分工与团队建设',
    quote:
      '培训的重点不在具体技术细节，而是在统一一个方向：AI 时代研发效率的核心是"端到端 AI 工具链"，而不是个人使用 AI 的能力。工具链复杂度高但复用性强，不适合让所有人参与建设，由少数核心成员负责沉淀、其他人直接使用——这一点对团队分工是一个比较大的认知转变。',
    accent: 'navy',
  },
  {
    id: 'tech-lead',
    role: 'Tech Lead',
    team: '团队约 10 人',
    theme: '测试治理与代码审查',
    quote:
      '培训精准指出了 AI 开发提效后测试环节承压的核心问题。针对 AI 大量生成代码后传统 Code Review 失效的问题，提出的"AI 生成文档、人工审核文档"方案，兼顾了审核效率与风险把控，可以直接应用于工作。',
    accent: 'orange',
  },
  {
    id: 'dev-manager',
    role: '研发经理',
    team: '',
    theme: '真实项目全流程与实战效果',
    quote:
      '培训直接以真实项目为演示对象，带我们完整走了一遍新系统从零到一的工程化过程——文档体系怎么建、AI 工作流怎么搭、端到端开发涉及哪些工具，每个环节都落到了实处。尤其是测试环节得到了系统强化，把可复用路径沉淀为技能库和自动化脚本后，更多环节可以实现基于大模型的自主流转，输出质量也更稳定。',
    accent: 'blue',
  },
  {
    id: 'qa-lead',
    role: '测试组长',
    team: '',
    theme: '测试自动化推广落地',
    quote:
      '测试方向上收获明显。回归测试引入 AI 的工作流程已经理清，准备在测试组内推广。新功能 AI 测试的整体思路也跑通了，方向明确，接下来还需要通过实际项目把经验积累起来。',
    accent: 'orange',
  },
  {
    id: 'frontend',
    role: '前端工程师',
    team: '',
    theme: '工具落地与人机协作节奏',
    quote:
      '工作流和环境配置的整体思路是最直接的收获，对工程化全流程——文档体系建立、Claude Code 实际用法——都有了具体认识。实际用这套工具链开发后效率提升明显，配合 Playwright 完成前端页面迁移的功能验证也印证了其实用性。协作节奏上，随 AI 改完即时查看、不符预期立刻介入调整，人机配合的流畅度比以前改善很多。',
    accent: 'navy',
  },
  {
    id: 'backend',
    role: '后端工程师',
    team: '',
    theme: '工程化体系与技能固化',
    quote:
      '主要价值在于通过规则与工具化的技能，构建一套无需复杂 Prompt 即可高效产出的工程化研发体系。把研发过程固化为 AI Skills，对固定重复工作沉淀出脚本，对需要动态推理的任务使用 Skill，让项目在完整生命周期里不跑偏。',
    accent: 'blue',
  },
];
